import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import ProblemSection from './components/ProblemSection';
import Services from './components/Services';
import WhyChoose from './components/WhyChoose';
import Process from './components/Process';
import About from './components/About';
import CTA from './components/CTA';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="site-bg text-white min-h-screen w-full overflow-x-hidden">
        <Header />
        <main className="w-full">
          <Routes>
            <Route path="/" element={
              <>
                <Hero />
                <ProblemSection />
                <Services />
                <WhyChoose />
                <Process />
                <About />
                <CTA />
              </>
            } />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;